import GitHubCalender from "react-github-calendar"

import "./Github.css"
export const Calender=()=>{
    
    return(
        <div  className="cal">
        <h1 className="cal_heading" >MY GITHUB CALENDER</h1>
        <GitHubCalender username="Rekha0980" />
    </div>
    )
}
